import { Injectable, Inject } from '@angular/core';
import { ProjectService } from '../../resources/project/project.service';
import { ConvertResourceToJsonPipe } from '../convert-resource-to-json/convert-resource-to-json.pipe';

@Injectable({
  providedIn: 'root'
})
export class CircularDetectionService {

  /** Legacy project dataservice reference. */
  private sgProjectDataService: any;

  constructor(
    @Inject('sgProjectDataService') sgProjectDataService: any,
    private convertResourceToJsonPipe: ConvertResourceToJsonPipe,
    private projectService: ProjectService
  ) {
    this.sgProjectDataService = sgProjectDataService;
  }

  /**
   * Find Circular errors in AngularJS $scope.
   *
   * @note Results are shown in Dev Console.
   */
  public findInScope(): void {
    this.sgProjectDataService.getProjectById('5d4bc9925c7ac60c9a70df6e').then(project => {
      project = this.convertResourceToJsonPipe.transform(project);
      this.find(project, 'in $scope');
    });
  }

  /**
   * Find Circular errors in Angular Datastore.
   *
   * @note Results are shown in Dev Console.
   */
  public findInStore(): void {
    const project = this.convertResourceToJsonPipe.transform(this.projectService.get());
    this.find(project, 'in datastore');
  }

  /**
   * Find circular errors in any object.
   *
   * Accepts Objects and Array of Objects.
   *
   * @param obj The object or array to check for errors
   * @param [location] String to display search location in console.
   */
  public find(obj: any, location?: string): boolean | void {
    const keys = [];
    const stack = [];
    const stackSet = new Set();
    let detected = false;
    let number = 0;

    const detect = ((object, key) => {
      if (!(object instanceof Object)) {
        return;
      }

      // Circular error found.
      if (stackSet.has(object)) {
        const oldindex = stack.indexOf(object);
        const l1 = `${keys.join('.')}.${key}`;
        const l2 = keys.slice(0, oldindex + 1).join('.');
        console.log(`CIRCULAR: ${l1} = ${l2} = ${object}`);
        console.log(object);
        detected = true;
        number++;
        return;
      }

      keys.push(key);
      stack.push(object);
      stackSet.add(object);
      Object.keys(object).forEach(k => { // dive on the object's children
        if (k && Object.prototype.hasOwnProperty.call(object, k)) {
          detect(object[k], k);
        }
      });

      keys.pop();
      stack.pop();
      stackSet.delete(object);
    });

    detect(obj, 'obj');

    if (number === 0) {
      console.log('No circular references found', location);
    }

    return detected;
  }
}
